import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiClient } from "app/configs/apiClient";

// get review data
export const getReviews = createAsyncThunk(
  "/get/reviews",
  async ({ page = 1, limit = 10, mob, date, url }) => {
   
    const response = await apiClient().get(url, {
      params: {
        mob: mob,
        date: date,
        page: page,
        limit: limit,
      },
    });

    return response.data;
  }
);

// patch for comment adding
export const sendReviewRequest = createAsyncThunk(
  "review/reply",
  async (params, thunkAPI) => {
 
    const { contacts, message_body, url } = params;
    const response = await apiClient().post(url, {
      contacts,
      message_body,
    });
    
    return response.data;
  }
);

const initialState = {
  mobileReviews: [],
  mobileReviews_error: null,
  total_count: 0,
};

const reviewSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    getReview(state, action) {
      return state.mobileReviews;
    },
    updateReview(state, action) {
      state.mobileReviews = [...action.payload];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getReviews.fulfilled, (state, action) => {
      state.mobileReviews = action.payload.data;
      state.total_count = action.payload.total_count;
    });
    builder.addCase(getReviews.pending, (state, action) => {
    });
    builder.addCase(getReviews.rejected, (state, action) => {
      //   state.review_error = "data not found";
    });
    builder.addCase(sendReviewRequest.fulfilled, (state, action) => {
    });
    builder.addCase(sendReviewRequest.pending, (state, action) => {
    });
    builder.addCase(sendReviewRequest.rejected, (state, action) => {
    });
  },
});

export default reviewSlice.reducer;
